@import './pk-segmented-control.variables';

:host {
  @apply flex;
}

.pk-segmented-control {
  &::before {
    @apply rounded-l bg-[--segmented-control--active-color] shadow-03 content-[''];
    @apply absolute left-[--segment--control--active-offset] top-xs3 h-[calc(100%_-_(var(--pk-spacing-xs3)_*_2))] w-[--segment-control--width];
    @apply transition-[left] duration-250;
  }
}
